<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['Whitelisted domains', editMode ? tDomainName : 'Add New']"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="wd-edit-domain">Domain</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="wdData.domainName"
                  name="domainName"
                  #domainName="ngModel"
                  class="form-control"
                  id="wd-domain"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(domainName.touched || domainName.dirty) && !domainName.valid">
                  Domain {{ errors['domainName'] || 'is invalid.' }}
                </small>
              </div>

              <div style="margin-top: 40px;">
                <button id='whitelistedDomainEditDelete' *ngIf="editMode" type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <span class="btn-right">
                  <button id='whitelistedDomainEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='whitelistedDomainEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/whitelisted-domains/whitelisted-domain-edit/whitelisted-domain-edit.component.html